<script>
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'Question',
  components: {
  },
  mixins: [snackbarMixin],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      answer: {},
    };
  },
  methods: {
    onNewAnswer() {
      let maxAnswerOrder;

      if (this.question.answers && this.question.answers.length > 0) {
        maxAnswerOrder = Math.max(...this.question.answers.map(it => it.orderNumber));
      } else {
        maxAnswerOrder = 0;
      }
      this.question.answers.push({ orderNumber: maxAnswerOrder + 1 });
    },
    onDeleteAnswer(index) {
      this.question.answers.splice(index, 1);
    },
    onDeleteQuestion() {
      console.log('onDeleteQuestion');
      this.$emit('delete', this.question.id);
    },
  },
};
</script>
<!-- TODO: Format. Dialog looks ugly. -->
<template>
  <div>
    <v-container fluid grid-list-lg pt-2 pa-2>
      <v-layout row wrap>
        <v-flex md12>
          <v-layout row wrap>
            <v-flex xs1 md1 py-0 class="number-field">
              <!-- TODO: Change to numeric input. -->
              <v-text-field
                v-model="question.orderNumber"
                height="22"
              />
            </v-flex>

            <v-flex xs11 md9 py-0>
              <v-textarea
                v-model="question.text"
                rows="3"
                height="22"
              />
            </v-flex>

            <v-flex xs1 md1 py-0>
              <v-btn @click="onDeleteQuestion" slot="activator" small fab flat>
                <v-icon color="red lighten-2">delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <div v-for="(answer, index) in question.answers" :key="index">
        <v-layout row wrap>
          <v-flex xs1 md1 py-0/>

          <v-flex xs1 md1 py-0 class="number-field">
            <!-- TODO: Change to numeric input. -->
            <v-text-field
              numeric="true"
              v-model="answer.orderNumber"
              height="22"
            />
          </v-flex>

          <v-flex xs12 md8 py-0>
            <v-textarea
              v-model="answer.text"
              rows="2"
              height="22"
            />
          </v-flex>

          <v-flex xs1 md1 py-0>
            <v-checkbox
              v-model="answer.isCorrect"
              label="Lösung"
              class="caption"
              hide-details
            />
          </v-flex>

          <v-flex xs1 md1 py-0>
            <v-btn @click="onDeleteAnswer(index)" slot="activator" small fab flat>
              <v-icon color="red lighten-2">delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>

      <v-layout row wrap>
        <v-flex xs5 md5 py-0/>
        <v-flex xs5 md5 py-0>
          <v-btn @click="onNewAnswer()" slot="activator" small>
            <span>Neue Antwort</span>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md12 style="height: 45px;"/>
      </v-layout>
    </v-container>
  </div>
</template>

<style>
  .number-field .v-input input {
    text-align: right !important;
  }
</style>
